import { Box, TextField, Typography } from "@mui/material";
import React from "react";

interface StepProps {
  formik: any;
}

const BecomeSellerFormStep1: React.FC<StepProps> = ({ formik }) => {
  return (
    <Box className="space-y-6">
      <Typography variant="h6" className="text-center font-bold pb-2">
        Primary Contact & Tax Information
      </Typography>

      <div className="space-y-5">
        <TextField
          fullWidth
          name="mobile"
          label="Primary Mobile Number"
          value={formik.values.mobile}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.mobile && Boolean(formik.errors.mobile)}
          helperText={formik.touched.mobile && formik.errors.mobile}
        />

        <TextField
          fullWidth
          name="taxPin"
          label="Tax PIN / KRA PIN / Registration ID"
          value={formik.values.taxPin}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.taxPin && Boolean(formik.errors.taxPin)}
          helperText={formik.touched.taxPin && formik.errors.taxPin}
        />
      </div>
    </Box>
  );
};

export default BecomeSellerFormStep1;